import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import React, {Fragment, useEffect, useState} from "react";
import {
    EditUserFieldNames,
    EditUserSubFormIdentifiers,
    ModalEditUserModes
} from "root/s360components/Modals/UserEdit/useModalEditUser";
import {useForm} from "react-hook-form";
import HookFormFragmentRenameUser from "root/s360components/Modals/UserEdit/HookFormFragmentRenameUser";
import ModalButton from "root/Modals/ModalButton";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import './ModalEditUser.scss';
import {getUserDetails, updateUsernameWithChecks} from "root/DataFunctions/EditUserFns";


export const EditUserFormData = (mode, data) =>
{
    switch(mode)
    {
        case ModalEditUserModes.RENAME:
            return {
                [EditUserSubFormIdentifiers.RENAME]:
                    {
                        [EditUserFieldNames.USERNAME]: data ? data.username : ''
                    }
            }
    }
}

const ModalEditUser = ({mode, enc_user_id, user_type, onClose, onSaveComplete}) =>
{
    const [data, setData] = useState({data: [], isLoading: true});

    const [ disableButtons, setDisableButtons ] = useState ( false ) ;

    const fetchRequired = () => {
        switch(mode){
            case ModalEditUserModes.RENAME:
                return true;
            default:
                return false;
        }
    };

    useEffect(() =>
    {
        if (fetchRequired())
        {
            getData();
        }
        else
        {
            setData({data: [], isLoading: false})
        }
    }, [])

    const getData = () =>
    {
        if (enc_user_id !== undefined && user_type !== undefined)
        {
            getUserDetails(enc_user_id, user_type, (response) =>
            {
                const record = response.results.record_set.length !== 0 ? response.results.record_set[0] : [];

                setData({data: record, isLoading: false});

                const values = getValues(EditUserSubFormIdentifiers.RENAME);

                const defVals = {
                    [EditUserSubFormIdentifiers.RENAME]: values,
                    ...EditUserFormData(mode, record)
                }

                reset(defVals);
            })
        }
    }


    const doSave = (formData) =>
    {
        switch(mode)
        {
            case ModalEditUserModes.RENAME:
            {
                updateUsernameWithChecks(enc_user_id, formData, user_type, (response) =>
                {
                    //Deal with varying responses depending on validation
                    if(response.custom_data !== undefined && response.custom_data !== null)
                    {
                        setError(EditUserSubFormIdentifiers.RENAME + '.' + EditUserFieldNames.USERNAME, {type: 'custom', message: response.custom_data.reason});

                        setDisableButtons(false) ;
                    }
                    else
                    {
                        onSaveCompleted();
                    }
                })
            }


        }
    }

    const onSubmit = (data) =>
    {
        setDisableButtons( true );
        doSave(data);
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const onClickCancel = () =>
    {
        onSaveComplete('cancel');
        onClose();
    }

    const onSaveCompleted = () =>
    {
        onSaveComplete('saved');
        onClose();
    }


    const {register, control, reset, getValues, handleSubmit, setFocus, watch, setError, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ...EditUserFormData(mode, null)
            }
        });

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
    }

    const pageModeDescriptors = {
        [ModalEditUserModes.RENAME] : { sectionName: EditUserSubFormIdentifiers.RENAME, fragment: HookFormFragmentRenameUser , saveButtonText: 'Confirm' , pageTitle: 'Edit Username' },
    }

    const formContent =  () =>
    {
        const descriptor = pageModeDescriptors[mode] ;

        if (descriptor)
        {
            const sectionName = descriptor.sectionName;
            const SubForm = descriptor.fragment;
            const saveButtonText = descriptor.saveButtonText;

            return (
                <Fragment>
                    <form>
                        <h3><i className='icon-check'></i> {descriptor.pageTitle}</h3>
                        <SubForm sectionName={sectionName} {...controlProps} formErrors={formErrors} key={sectionName}/>
                        <div className='modal-buttons'>
                            <ModalButton onClick={onClickCancel} text='Cancel' iconClass='et-arrow-bold-left'
                                         additionalClass='btn-secondary' disabled={disableButtons}/>
                            <ModalButton onClick={onClickSaveForm} text={saveButtonText} iconClass='et-check'
                                         additionalClass='btn-primary' disabled={disableButtons}/>
                        </div>
                    </form>
                </Fragment>
            )
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            {data.isLoading === false &&
                <Fragment>
                    {formContent()}
                </Fragment>
            }
            {
                data.isLoading === true &&
                <div className='spinner-with-margin'>
                    <SpinnerDiv/>
                </div>
            }
        </ModalContentWrapper>
    )


}

export default ModalEditUser;